import { wrapRequest } from "./helpers";
import axios from "axios";

const loginUserRequest = (uri, user) => {
  console.log("runing login user req");
  return axios.post(uri, user);
};
const requestWithError = () =>
  fetch("https://jsonplaceholder.typicode.com/users_noop");

export const getUserBook = wrapRequest((url, config) => axios.get(url, config));
export const loginUser = wrapRequest(loginUserRequest);
export const wrappedRequestWithError = wrapRequest(requestWithError);
